module.exports = __webpack_public_path__ + "preview-eac7acfc/ibm-plex-mono-bold-ad4e2f3182a987b2675ad1ea1f10b6a0.woff";